import React, { useContext } from "react";

//styling
import "./clusterRow.css";

//global state
import { StateContext } from "../../AppStateContext";

//Material UI stuff
import TableCell from "@material-ui/core/TableCell";

const ClusterRowInfoModule = ({ clusterInfo }) => {
  //consume global state
  const state = useContext(StateContext);
  const getModuleNames = (modules) => {
    return modules.map(m => m.name).join(", ");
  }

  return (
    <TableCell
      align="left"
      style={{
        borderBottom: state.theme === "dark" ? "1px solid #122742" : "1px solid #eaeaea",
      }}
    >
      <p
        style={{ width: "fit-content" }}
        styles={{ margin: "0" }}
        className={state.theme === "dark" ? "__tableCell __tableCellDark" : "__tableCell __tableCellLight"}
      >
        {clusterInfo.data.configuration.modules && clusterInfo.data.configuration.modules[0]
          ? getModuleNames(clusterInfo.data.configuration.modules)
          : "none"}
      </p>
    </TableCell>
  );
};

export default ClusterRowInfoModule;
